@use '../../resources/styles/tokens' as *;
@import '../../resources/styles/grid-mag.scss';

$shadow:
  0px 4px 20px 0px rgba($colour-purple-700, 0.1),
  0px 0px 5px 0px rgba($colour-purple-700, 0.1);

.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 20px;
  border-radius: 8px;
  line-height: 18px;
  position: relative;
  z-index: 1;
  box-shadow: $shadow;
  background-color: $colour-background-primary;

  &.info {
    border-left: 8px solid $colour-blue-500;
  }

  &.warning {
    border-left: 8px solid $colour-amber-500;
  }

  &.error {
    border-left: 8px solid $colour-red-500;
  }

  &.floating {
    border: none;
    box-shadow: $shadow;
  }

  &.compact {
    padding: 10px;
  }

  &.marginBottom {
    margin-bottom: $spacing-8x;
  }

  &.column {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: $spacing-3x;
  }
}

.left {
  display: flex;
  flex: 0 0 auto;
  margin-right: 20px;
  padding: $spacing-half 0;

  .icon {
    min-width: 24px;
  }

  .clickable {
    cursor: pointer;
  }
}

.compact > .left {
  margin-right: 10px;
}

.center {
  flex: 1 1 auto;
  text-align: left;
}

.right {
  margin-left: 20px;
  flex: 0 0 auto;
}

.column .right {
  margin: 0;
}

.button {
  margin-top: auto;
}

.link {
  margin-top: auto;
  margin-bottom: $spacing-3x;
}

.triangle {
  $triangleSize: 22px;
  $triangleContainerWidth: 34px;
  $triangleContainerHeight: 32px;
  $triangleInset: 45px;

  position: absolute;
  z-index: 2;
  overflow: hidden;

  .triangle-inner {
    position: absolute;
    width: $triangleSize;
    height: $triangleSize;
    background: $colour-background-primary;
    box-shadow: $shadow;
  }

  &.br,
  &.bl,
  &.tr,
  &.tl {
    width: $triangleContainerWidth;
    height: $triangleContainerHeight;

    .triangle-inner {
      left: 50%;
      transform: translateX(-50%) scale(0.8, 1.2) rotate(45deg);
    }
  }

  &.br,
  &.bl {
    bottom: -$triangleContainerHeight;

    .triangle-inner {
      bottom: $triangleSize;
    }
  }

  &.bl,
  &.tl {
    left: $triangleInset;
  }

  &.br,
  &.tr {
    right: $triangleInset;
  }

  &.tr,
  &.tl {
    top: -$triangleContainerHeight;

    .triangle-inner {
      top: $triangleSize;
    }
  }

  &.l,
  &.r {
    top: 50%;
    transform: translateY(-50%);
    width: $triangleContainerHeight;
    height: $triangleContainerWidth;

    .triangle-inner {
      top: 50%;
      transform: translateY(-50%) scale(1.2, 0.8) rotate(45deg);
    }
  }

  &.l {
    left: -$triangleContainerHeight;

    .triangle-inner {
      left: $triangleSize;
    }
  }

  &.r {
    right: -$triangleContainerHeight;

    .triangle-inner {
      right: $triangleSize;
    }
  }
}

.survey {
  flex-direction: column;
  align-items: flex-start;

  .textIconWrapper {
    display: flex;
  }

  .center {
    padding-right: 6rem;

    @media (max-width: $xsmallBreakpoint) {
      padding-right: 0;
    }
  }

  .link {
    margin: 15px 0 0;
  }

  .left {
    transform: translate(10px, -9px);
    cursor: pointer;
  }
}
